import {
    classNamesFunction,
    IButtonStyles,
    IDropdownStyles,
    IStyle,
    ITheme,
} from '@fluentui/react';
import { SourceApps } from '../../../models/constants/constants';
import { color as themesColor } from './themes';
import { color, IThemedProp } from './themesUI';

export interface IContactUsStyles {
    panelGroup: IStyle;
    panel: IStyle;
    panelBody: IStyle;
    panelHeading: IStyle;
    arrow: IStyle;
    col: IStyle;
    h2: IStyle;
    articleContentShortened: IStyle;
    articleSection: IStyle;
    searchSnippet: IStyle;
    articleLink: IStyle;
    bodyCopySmall: IStyle;
    banner: IStyle;
    fieldSection: IStyle;
    fieldLabel: IStyle;
    fieldLabelRequired: IStyle;
    fieldFlexLine: IStyle;
    dialingCodeDropdown: IStyle;
    fieldInputGroup: IStyle;
    fieldInput: IStyle;
    confirmButton: IStyle;
    row: IStyle;
    modalityOption: IStyle;
    modalityOptionTitle: IStyle;
    upsellContainer: IStyle;
    upsellTitle: IStyle;
    upsellDescription: IStyle;
    upsellSubdescription: IStyle;
    upsellScenario: IStyle;
    upsellChatWeighted: IStyle;
    payOptionHeader: IStyle;
    payOptionDescription: IStyle;
    serviceAgreementMessage: IStyle;
    upsellCheckbox: IStyle;
    upsellAgentAssistSubscribeButton: IStyle;
    wrapText: IStyle;
    requestModalityIcon: IStyle;
    modalityDescription: IStyle;
    descriptionHtmlText: IStyle;
    alchemyThemeDropdown: IStyle;
    icon: IStyle;
    iconText: IStyle;
    iconSection: IStyle;
    backBtnContainer: IStyle;
    backBtnLabel: IStyle;
    fullHeightContainer: IStyle;
    containerFluid: IStyle;
    contactUsFooter: IStyle;
    signUpDescription: IStyle;
    signUpFooter: IStyle;
    stickyFooterRow: IStyle;
    stickyFooterFixed: IStyle;
    contactUsFooterBtnArea: IStyle;
    caption: IStyle;
    link: IStyle;
    noGutter: IStyle;
    sectionHeaderMainDescription: IStyle;
    chatNavBackInactive: IStyle;
    iconArrowBack: IStyle;
    dynamicHoopsLine: IStyle;
    dayOfWeek: IStyle;
    requestCreationTab: IStyle;
    requestConfirmation: IStyle;
    requestConfirmationHeader: IStyle;
    requestConfirmationProperty: IStyle;
    requestConfirmationPropertyLabel: IStyle;
    requestConfirmationPropertyValue: IStyle;
    requestConfirmationHr: IStyle;
    requestConfirmationMessageText: IStyle;
    issueDescription: IStyle;
    unAuthLink: IStyle;
    contactUsBody: IStyle;
    regionalSettingsHeader: IStyle;
    regionalSettingsTitle: IStyle;
    hideRegionalSettings: IStyle;
    outlineNone: IStyle;
    extraPaddingBottomOnSectionHeader: IStyle;
    timeZoneDropdownItem: IStyle;
    requestCreationIssueDescription: IStyle;
}

export interface IContactUsStyleProps {
    sourceApp?: SourceApps;
    isTeams?: boolean;
    isNonAgave?: boolean;
    isAgave?: boolean;
    isSignUp?: boolean;
    isDarkTheme?: boolean;
    showAgentModalitiesButtonClicked?: boolean;
}

export const getContactUsStyles = (props: IContactUsStyleProps & IThemedProp): IContactUsStyles => {
    const { theme, sourceApp, isTeams, isNonAgave, isAgave, isDarkTheme, isSignUp, showAgentModalitiesButtonClicked } = props;
    return {
        panelGroup: {
            marginBottom: '0',
        },
        panel: {
            boxShadow: 'none',
            border: 'none',
            backgroundColor: 'transparent',
            a: {
                textDecoration: 'none !important',
            },
            selectors: {
                '-webkit-box-shadow': 'none',
            },
            p: {
                fontSize: 'inherit',
            },
        },
        panelBody: {
            padding: '0',
            paddingTop: '15px',
            color: theme.palette.neutralPrimary,
        },
        panelHeading: {
            padding: '0',
            lineHeight: '22px',
            borderBottom: '.5px solid #ccc',
            height: '35px',
            selectors: {
                '@media only screen and (max-width: 480px) ': {
                    height: '26px',
                },
            },
            marginTop: isSignUp && '10px',
        },
        col: {
            padding: '0 !important',
            marginLeft: '0 !important',
            marginRight: '0 !important',
        },
        h2: {
            fontFamily: !isTeams && sourceApp !== SourceApps.SurfaceApp && sourceApp !== SourceApps.SurfaceApp2 && !isAgave
                ? "'Segoe UI Light','Segoe WP Light','wf_segoe-ui_light','wf_segoe-ui_normal','Segoe UI','Segoe WP',Helvetica,Tahoma,Arial,sans-serif"
                : "'Segoe UI Semibold','wf_segoe-ui_semibold','wf_segoe-ui_normal','Segoe UI','Segoe WP',Tahoma,Arial,sans-serif",
            fontWeight: !isTeams && sourceApp !== SourceApps.SurfaceApp && sourceApp !== SourceApps.SurfaceApp2 && !isAgave ? '300' : '600',
            fontSize: !isTeams && sourceApp !== SourceApps.SurfaceApp && sourceApp !== SourceApps.SurfaceApp2 && !isAgave
                ? '26px'
                    ? '26px'
                    : '3em'
                        ? '26px'
                        : '3em'
                : '16px',
            lineHeight: !isTeams && sourceApp !== SourceApps.SurfaceApp && sourceApp !== SourceApps.SurfaceApp2 && !isAgave
                ? isNonAgave
                    ? 'none'
                    : '1.33'
                : '21px',
            color: theme.palette.neutralPrimary,
            marginTop: !isTeams && sourceApp !== SourceApps.SurfaceApp && sourceApp !== SourceApps.SurfaceApp2 && !isAgave ? '48px' : '32px',
            marginBottom: '20px',
            selectors: {
                '@media only screen and (max-width: 480px) ': {
                    fontSize: !isTeams && sourceApp !== SourceApps.SurfaceApp && sourceApp !== SourceApps.SurfaceApp2 && !isAgave && '18px',
                    lineHeight: !isTeams && sourceApp !== SourceApps.SurfaceApp && sourceApp !== SourceApps.SurfaceApp2 && !isAgave && '1.19',
                    marginTop: !isTeams && sourceApp !== SourceApps.SurfaceApp && sourceApp !== SourceApps.SurfaceApp2 && !isAgave && '32px',
                    marginBottom: !isTeams && sourceApp !== SourceApps.SurfaceApp && sourceApp !== SourceApps.SurfaceApp2 && !isAgave && '20px',
                },
            },
        },
        arrow: {
            verticalAlign: 'middle',
            paddingTop: '6px',
            fontSize: '12px',
            color: theme.semanticColors.link,
            fontWeight: '500',
            selectors: {
                '@media only screen and (max-width: 480px) ': {
                    paddingTop: '0',
                    fontSize: '10px',
                },
            },
        },
        articleContentShortened: {
            lineHeight: '16px',
            maxHeight: '38px',
            display: 'block',
        },
        articleSection: {
            margin: '10px 0 0 0 !important',
        },
        searchSnippet: {
            whiteSpace: 'pre-wrap',
            fontSize: '14px',
            lineHeight: 'normal',
            color: theme.palette.neutralPrimary,
        },
        articleLink: {
            fontSize: '16px',
            fontWeight: '500',
            textDecoration: 'none',
            selectors: {
                '@media only screen and (max-width: 480px) ': {
                    fontSize: '14px',
                },
            },
            color: theme.semanticColors.link,
        },
        bodyCopySmall: {
            fontFamily: "'Segoe UI','Segoe UI Web','wf_segoe-ui_normal','Helvetica Neue','BBAlpha Sans','S60 Sans',Arial,sans-serif",
            color: theme.palette.neutralPrimary,
            fontSize: '14px',
            lineHeight: '1.5',
            marginBottom: '3px',
            a: {
                color: theme.semanticColors.link,
            },
        },
        banner: {
            fontSize: '10px',
            background: theme.palette.neutralLighterAlt,
            lineHeight: '12px',
            padding: '1px 2px',
        },
        fieldSection: {
            marginBottom: '10px',
        },
        fieldLabel: {
            fontWeight: '500',
        },
        fieldLabelRequired: {
            color: theme.palette.red,
        },
        fieldFlexLine: {
            display: 'flex',
            flexWrap: 'wrap',
        },
        dialingCodeDropdown: {
            height: '32px',
            border: 'none',
            margin: '4px 0 0 0',
            flex: '1',
            paddingLeft: '6px',
            borderRadius: '2px',
            backgroundColor: theme.semanticColors.inputBackground,
            option: {
                borderRadius: '2px',
                ':hover': {
                    color: `${theme.palette.neutralPrimary}!important`,
                    backgroundColor: theme.semanticColors.inputBackground,
                },
            },
        },
        fieldInputGroup: {
            marginTop: '4px',
            flex: '2',
            background: theme.semanticColors.inputBackground,
        },
        fieldInput: {
            border: '1px solid #ccc',
            background: `${theme.semanticColors.inputBackground} !important`,
            color: `${theme.palette.neutralPrimary} !important`,
        },
        confirmButton: {
            marginRight: '20px',
        },
        row: {
            padding: '0',
            margin: '0',
        },
        modalityOption: {
            marginBottom: '10px !important',
        },
        modalityOptionTitle: {
            fontSize: '16px',
            fontWeight: '500',
        },
        upsellContainer: {
            marginTop: '25px !important',
            fontWeight: '500',
            border: '2px solid #D3D3D3',
            padding: '14px 14px 0px 14px !important',
            fontSize: '14px',
            borderRadius: '5px',
            lineHeight: '20px',
            width: '75% !important',
        },
        upsellTitle: {
            fontWeight: '600',
        },
        upsellDescription: {
            fontWeight: '400',
        },
        upsellScenario: {
            border: '1px solid #E1DFDD',
            borderRadius: '3px',
            padding: '20px',
        },
        upsellSubdescription: {
            fontWeight: '400',
            marginTop: '15px',
            color: '#605E5C',
            overflowWrap: 'normal',
            whiteSpace: 'normal',
            marginBottom: '8px',
        },
        upsellChatWeighted: {
            background: '#EDEBE9',
        },
        payOptionHeader: {
            fontSize: '14px',
            fontStyle: 'normal',
            lineHeight: '20px',
            fontWeight: '700',
            marginTop: '16px',
            marginBottom: '22px',
        },
        payOptionDescription: {
            marginLeft: '22px',
        },
        serviceAgreementMessage: {
            marginTop: '50px !important',
            color: theme.palette.neutralPrimary,
            whiteSpace: 'normal',
            a: {
                textDecoration: 'underline solid !important',
            },
        },
        upsellCheckbox: {
            marginTop: '25px',
        },
        upsellAgentAssistSubscribeButton: {
            marginTop: '20px',
        },
        wrapText: {
            overflowWrap: 'normal',
            whiteSpace: 'normal',
        },
        requestModalityIcon: {
            marginRight: '5px',
        },
        modalityDescription: {
            fontFamily: '"Segoe UI ", "Segoe UI Web ", "wf_segoe-ui_normal","Helvetica Neue", "BBAlpha Sans", "S60 Sans", Arial, sans-serif',
            fontSize: '14px',
            marginBottom: '0px',
            lineHeight: 'normal',
        },
        descriptionHtmlText: {
            whiteSpace: 'normal',
            'a#communityForumLink': {
                textDecoration: 'underline solid !important',
            },
        },
        alchemyThemeDropdown: {
            width: '100% !important',
            padding: '0 !important',
            border: 'none !important',
            '-webkit-box-shadow': 'none !important',
        },
        icon: {
            fontSize: '18px',
            lineHeight: '16px',
            selectors: {
                '@media only screen and (max-width: 480px) ': {
                    fontSize: '16px',
                    lineHeight: '14px',
                },
            },
        },
        iconText: {
            paddingLeft: '10px',
            color: theme.semanticColors.link,
            fontSize: '16px',
            fontWeight: '500',
        },
        iconSection: {
            margin: '0 0 8px 0',
            lineHeight: '2',
            selectors: {
                '@media only screen and (max-width: 480px) ': {
                    margin: '0 0 6px 0',
                },
            },
        },
        backBtnContainer: {
            fontSize: '14px',
            fontWeight: 'normal',
            cursor: 'pointer',
            border: 'none',
            backgroundColor: 'transparent',
        },
        backBtnLabel: {
            margin: '0px 0px 3px 0px',
            lineHeight: '2',
            paddingLeft: '15px',
        },
        fullHeightContainer: {
            minHeight: '58vh',
            marginBottom: (isNonAgave || isTeams) && '59px',
            selectors: {
                '@media only screen and (max-width: 480px) ': {
                    minHeight: '80vh',
                },
            },
        },
        containerFluid: {
          padding: '0 17px',
          height: (isTeams || sourceApp === SourceApps.SurfaceApp || sourceApp === SourceApps.SurfaceApp2) && '100%',
        },
        contactUsFooter: {
            width: '100%',
            background: `${theme.palette.white} !important`,
            margin: '0',
            marginTop: '15px',
            minWidth: '320px',
            zIndex: '10000',
            maxWidth: 'none',
            minHeight: '59px',
            borderTop: `1px solid ${theme.palette.neutralPrimaryAlt}`,
            padding: '11px 0 10px',
            boxShadow: (isTeams || sourceApp === SourceApps.SurfaceApp || sourceApp === SourceApps.SurfaceApp2) ? '0 -2px 4px rgba(0,0,0,0.1)' : 'none',
        },
        signUpDescription: {
            paddingBottom: showAgentModalitiesButtonClicked ? '10px' : '64px',
        },
        signUpFooter: {
            background: `${theme.palette.white} !important`,
            margin: '0',
            marginTop: '15px',
            width: '100%',
            zIndex: '10000',
        },
        stickyFooterRow: {
            paddingRight: '15px',
            paddingLeft: '15px',
            marginRight: 'auto',
            marginLeft: 'auto',
        },
        stickyFooterFixed: {
            bottom: '0',
        },
        contactUsFooterBtnArea: {
            maxWidth: '768px',
        },
        caption: {
            fontFamily: "'Segoe UI','Segoe UI Web','wf_segoe-ui_normal','Helvetica Neue','BBAlpha Sans','S60 Sans',Arial,sans-serif",
            fontSize: '12px',
            lineHeight: '16px',
            color: isDarkTheme
                    ? color.white
                    : (props.isNonAgave ?? false) ||
                    !(props.isAgave ?? true) ||
                    props.sourceApp === null ||
                    props.theme?.semanticColors.bodyBackground.substring(0, 7).toLowerCase() === themesColor.gray.toLowerCase()
                        ? '#6D6D6D'
                        : '#6F6F6F',
            marginTop: '3px !important',
            marginBottom: '3px !important',
        },
        link: {
            color: theme.semanticColors.link,
        },
        noGutter: {
            padding: '0',
            margin: '0 !important',
        },
        extraPaddingBottomOnSectionHeader: {
            paddingBottom: '8px',
        },
        sectionHeaderMainDescription: {
            fontWeight: '400',
            fontSize: '14px',
            lineHeight: '20px',
            color: theme.palette.neutralPrimary,
            selectors: {
                a: {
                    textDecoration: 'underline solid',
                },
            },
        },
        chatNavBackInactive: {
            opacity: '0.5',
            filter: 'grayScale(100%)',
        },
        iconArrowBack: {
            padding: '0',
            float: 'left',
            lineHeight: '30px',
            fontSize: '14px',
            height: '30px',
            cursor: 'pointer',
            span: {
                color: color.white,
            },
        },
        dynamicHoopsLine: {
            display: 'flex',
            selectors: {
                '@media (max-width: 300px) ': {
                    flexDirection: 'column',
                },
            },
        },
        dayOfWeek: {
            width: '180px',
        },
        requestCreationTab: {
            paddingTop: '15px',
        },
        requestConfirmation: {
            whiteSpce: 'normal',
        },
        requestConfirmationHeader: {
            fontSize: '16px',
            fontWeight: '500',
            marginBottom: '10px',
        },
        requestConfirmationProperty: {
            display: 'flex',
        },
        requestConfirmationPropertyLabel: {
            fontWeight: '500',
            margin: '5px 5px 5px 0px',
            flexBasis: '150px',
        },
        requestConfirmationPropertyValue: {
            margin: '5px 5px',
        },
        requestConfirmationHr: {
            margin: '10px 0px',
            borderTop: '2px solid #767676',
        },
        requestConfirmationMessageText: {
            fontWeight: '500',
        },
        issueDescription: {
            minWidth: '1px',
            padding: '13px 17px 17px 17px',
        },
        requestCreationIssueDescription: {
            minWidth: '1px',
            padding: '13px 17px 17px 17px',
            color: 'inherit',
            background: 'inherit',
            font: 'inherit'
        },
        unAuthLink: {
            marginLeft: '16px',
            fontSize: '14px',
        },
        contactUsBody: {
            maxWidth: '768px',
            selectors: {
                '@media only screen and (max-width: 480px) ': {
                    width: '100%',
                },
            },
        },
        regionalSettingsHeader: {
            display: 'flex',
        },
        regionalSettingsTitle: {
            textDecoration: 'none !important',
            flexGrow: 1,
        },
        hideRegionalSettings: {
            display: 'none',
        },
        outlineNone: {
            outline: 'none',
        },
        timeZoneDropdownItem: {
            '@media screen and (max-width: 640px)': {
                '& span.ms-Dropdown-optionText': {
                    whiteSpace: 'normal',
                },
            },
        },
    };
};

export const getPrimaryButtonStyles = (props: IThemedProp): IButtonStyles => {
    const { theme } = props;
    return {
        root: {
            selectors: {
                '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
                    color: 'window !important',
                    backgroundColor: 'windowtext !important',
                    borderColor: 'windowtext !important',
                    forcedColorAdjust: 'none',
                },
            },
            border: '1px solid',
            borderColor: `${theme.palette.themeTertiary} !important`,
            borderRadius: '0',
            padding: '6px 12px',
            margin: '15px 0',
            verticalAlign: 'middle',
            fontFamily: 'inherit',
        },
        rootHovered: {
            selectors: {
                '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
                    color: 'window !important',
                    backgroundColor: 'highlight !important',
                    borderColor: 'highlight !important',
                },
            },
            borderColor: theme.palette.themeDark,
        },
        rootFocused: {
            selectors: {
                '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
                    backgroundColor: 'windowtext !important',
                },
            },
            backgroundColor: `${theme.palette.themeDark} !important`,
            borderColor: `${theme.palette.blueDark} !important`,
            outline: '5px auto -webkit-focus-ring-color',
            outlineOffset: '-2px',
            textDecoration: 'none',
        },
        rootPressed: {
            selectors: {
                '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
                    backgroundColor: 'windowtext !important',
                },
            },
            borderColor: `${theme.palette.blueDark} !important`,
            outline: '5px auto -webkit-focus-ring-color',
            outlineOffset: '-2px',
            textDecoration: 'none',
        },
        label: {
            lineHeight: '1.42857143',
            fontWeight: '400',
            fontSize: '14px',
        },
    };
};

export const getGetHelpDropdownStyles = (theme: ITheme): Partial<IDropdownStyles> => ({
    root: {
        maxWidth: '400px',
        borderRadius: '4px',
    },
    title: {
        maxWidth: '400px',
        borderRadius: '4px',
        borderColor: theme.palette.neutralLight,
        bottomBorderColor: theme.palette.neutralTertiaryAlt,
        background: theme.semanticColors.inputBackground,
        selectors: {
            ':hover': {
                backgroundColor: theme.palette.neutralLighterAlt,
                borderColor: theme.palette.neutralLight,
                color: theme.palette.black,
            },
            ':focus': {
                color: theme.palette.black,
                borderColor: theme.palette.black,
            },
        },
    },
    dropdownItemsWrapper: {
        background: theme.palette.neutralLighterAlt,
    },
});

export const getContactUsClassNames = classNamesFunction<{}, IContactUsStyles>();
